import styled, { css } from 'styled-components'
import IconInputError from '../../../assets/icons/icon-input-error.svg'
import IconInputSuccess from '../../../assets/icons/icon-input-success.svg'
import IconVisa from '../../../assets/img/pagamento/cartao-visa.svg'
import IconAmex from '../../../assets/img/pagamento/cartao-amex.svg'
import IconMaster from '../../../assets/img/pagamento/cartao-mastercard.svg'
import IconDiners from '../../../assets/img/pagamento/cartao-diners.svg'
import IconElo from '../../../assets/img/pagamento/cartao-elo.svg'
import IconCartao from '../../../assets/img/pagamento/cartao-default.svg'

export const Register = styled.section`
  background: #fff;
`
export const ProfileTitle = styled.h2`
  font-size: 22px;
  margin-bottom: 20px;
  color: #555;
`

export const WrapperSmall = styled.div`
  max-width: 300px;
  width: 100%;

  .header {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;

    img {
      width: 72px;
    }

    h3 {
      font-size: 24px;
      font-weight: 600;
      margin-bottom: 16px;
      line-height: 29px;
    }
  }

  p {
    font-size: 14px;
  }
`

export const RegisterCard = styled.div`
  ${({ theme, type }) => css`
    padding: 16px;
    background: #ffffff;
    border: 1px solid #e5e5e5;
    border-radius: 4px;
    -webkit-box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1);
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1);
    margin: 16px 0;

    ${type === 'insideModal' &&
    css`
      border: none;
      box-shadow: none;
      padding: 0;
      margin-bottom: 0;
    `}

    p {
      margin-bottom: 20px;
      margin-top: 0;
    }

    label {
      font-weight: 500;

      @media (max-width: 600px) {
        font-size: 14px;
      }
    }

    small {
      margin-bottom: 5px;
      font-size: 13px;
      line-height: 22px;
    }

    h3 {
      font-size: 26px;
      font-weight: 500;
      margin-bottom: 16px;
    }

    form div {
      /* margin-bottom: 16px; */
    }

    [type='checkbox']:not(:checked) + label::after,
    [type='checkbox']:checked + label::after {
      left: 4px;
    }

    @media (max-width: 600px) {
      min-width: 100%;
      /* padding: 32px 20px 12px 20px; */
    }
  `}
`

export const Title = styled.h2`
  font-weight: 500;
  color: #333;
  margin-bottom: 12px;
  text-align: left;
  background-color: blue;
  font-size: 34px;

  @media (max-width: 1170px) {
    font-size: 18px;
    text-align: left;
  }
`

export const CardImage = styled.div`
  ${({ cartao }) => css`
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    background-size: contain;
    display: flex;
    width: 81px;
    margin-left: 8px;
    margin-bottom: 0px !important;

    ${cartao === undefined || cartao === null
      ? css`
          background-image: url(${IconCartao});
        `
      : null}

    ${cartao === 'amex' &&
    css`
      background-image: url(${IconAmex});
    `}

    ${cartao === 'mastercard' &&
    css`
      background-image: url(${IconMaster});
    `}

    ${cartao === 'visa' &&
    css`
      background-image: url(${IconVisa});
    `}

    ${cartao === 'elo' &&
    css`
      background-image: url(${IconElo});
    `}

    ${cartao === 'diners' &&
    css`
      background-image: url(${IconDiners});
    `}
  `}
`

export const Input = styled.input`
  ${({ theme }) => css`
    border: 1px solid #afaeae;
    border-radius: 4px;
    padding: 15px 15px;
    width: 100%;
    transition: all 400ms;

    &::placeholder {
      font-family: 'Montserrat', sans-serif;
      font-weight: 400;
      color: #afaeae;
    }

    &:focus {
      border-color: ${theme.colors.primary};
    }

    // Feedbacks.
    &.input-success {
      background: ${theme.colors.backgroundSuccess} url(${IconInputSuccess})
        right 10px center no-repeat !important;
      border-color: ${theme.colors.success};
    }

    &.input-error {
      background: ${theme.colors.backgroundError} url(${IconInputError}) right
        10px center no-repeat !important;
      border-color: ${theme.colors.error};
    }
  `}
`

export const ProfileBoxFooter = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0;
`

export const Button = styled.button`
  ${({ theme, type }) => css`
    max-width: 200px;
    width: 100%;
    margin-right: 12px;

    border-radius: 4px;
    border: 2px solid transparent;
    font-family: 'Montserrat', sans-serif;
    font-weight: 500;
    font-size: 16px;
    padding: 12px 30px;
    margin-bottom: 10px;
    width: 100%;
    text-align: center;
    transition: ${theme.transition.default};
    cursor: pointer;
    background: ${theme.colors.primary};
    color: ${theme.colors.white};

    &.white {
      background: #fff;
      color: #707070;
      font-weight: 400;

      &:hover {
        background: #fff;
      }
    }

    &:hover {
      background: #a71e26;
    }

    & + .button {
      margin-left: 15px;
    }

    @media (max-width: ${theme.media.cel}) {
      font-size: 14px;
    }

    &.button-outline {
      max-width: 146px;
      background: transparent;
      border: 2px solid #8f8f8f;
      color: #8f8f8f;

      &:hover {
        border-color: #4a4a4a;
        color: #4a4a4a;
      }

      &:disabled {
        color: #7b7b7b;
        border-color: #7b7b7b;
        cursor: initial;
      }
    }

    ${type === 'insideModal' &&
    css`
      max-width: 100%;
      background: ${theme.colors.cart};
      margin-right: 0;
      margin-bottom: 0;

      &:hover {
        background: #33a161;
      }
    `}

    @media (max-width: 1170px) {
      & + .button {
        margin-left: 0;
        margin-top: 8px;
      }
    }
  `}
`
